const RECENT_KEY = 'maie:encounter:recentTemplates';
const RECENT_MAX = 5;

export function readRecentTemplateIds(): string[] {
  try {
    const raw = localStorage.getItem(RECENT_KEY);
    return raw ? (JSON.parse(raw) as string[]) : [];
  } catch {
    return [];
  }
}

export function rememberRecentTemplate(id: string) {
  try {
    const prev = readRecentTemplateIds().filter((x) => x !== id);
    const next = [id, ...prev].slice(0, RECENT_MAX);
    localStorage.setItem(RECENT_KEY, JSON.stringify(next));
  } catch {
    // ignore quota / privacy-mode errors
  }
}
